export const effects = new Set(["inkReveal"])

